import { GraphQLError } from 'graphql';

export const isAccessDeniedError = (error: GraphQLError): boolean => {
	return /Access denied/i.test(error.message);
};
